import { forwardRef, type Ref, type SVGProps } from "react";
const IconSettingsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M28.84 13.44h-.11l-3.17-.36a9 9 0 0 0-.72-1.74l2-2.5.07-.09a1.51 1.51 0 0 0-.21-1.85l-1.58-1.59a1.53 1.53 0 0 0-1.85-.21l-.09.07-2.5 2a9 9 0 0 0-1.74-.72l-.36-3.17v-.11A1.52 1.52 0 0 0 17.11 2h-2.22a1.52 1.52 0 0 0-1.46 1.16v.11l-.36 3.17a9 9 0 0 0-1.74.72l-2.49-2-.11-.06a1.53 1.53 0 0 0-1.85.21L5.31 6.88a1.51 1.51 0 0 0-.21 1.85l.07.09 2 2.49a9 9 0 0 0-.72 1.74l-3.17.36h-.11A1.5 1.5 0 0 0 2 14.89v2.22a1.52 1.52 0 0 0 1.16 1.46h.11l3.17.36c.186.6.427 1.183.72 1.74l-2 2.5-.07.09a1.51 1.51 0 0 0 .21 1.85l1.57 1.57a1.54 1.54 0 0 0 1.06.43 1.47 1.47 0 0 0 .79-.22l.09-.07 2.5-2c.557.293 1.14.534 1.74.72l.36 3.17v.11A1.52 1.52 0 0 0 14.89 30h2.22a1.52 1.52 0 0 0 1.46-1.16v-.11l.36-3.17c.6-.186 1.183-.427 1.74-.72l2.5 2 .09.07c.237.147.511.223.79.22a1.54 1.54 0 0 0 1.06-.43l1.57-1.57a1.51 1.51 0 0 0 .21-1.85l-.07-.09-2-2.5c.293-.557.534-1.14.72-1.74l3.17-.36h.11A1.52 1.52 0 0 0 30 17.11v-2.22a1.5 1.5 0 0 0-1.16-1.45M16 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSettingsFilledSVG);
ForwardRef.displayName = "IconSettingsFilled";
export { ForwardRef as IconSettingsFilled };
